import React from 'react';
import { Query } from '@apollo/client/react/components';
import PropTypes from 'prop-types';

import { PubNubSubscribe } from 'pubnub-subscribe';
import { GET_CURRENT_USER } from 'client-web-app/queries';
import { getRoleGroup } from 'user-utils';
import SidebarButton from './SidebarButton';
import { GET_UNREAD_MESSAGE_COUNT } from './queries';

/**
 * Builds a message handler that refetches the query if necessary
 * @param {String} clientId
 * @param {Object} history
 * @param {Function} refetch
 */
export const buildIncomingPubNubMessageHandler = (clientId, history, refetch) => message => {
  const isMessageReadEvent = message.name === 'feed.messages.read';
  const isMessageCreatedEvent = message.name === 'feed.message.created';
  const isMessageIntendedForClient =
    message.context && message.context.eventSource.authorId !== clientId;
  const isNotOnMessageFeed = history.location.pathname !== '/';

  if (
    isMessageReadEvent ||
    (isMessageCreatedEvent && isMessageIntendedForClient && isNotOnMessageFeed)
  ) {
    refetch();
  }
};

class MessageButtonContainer extends React.Component {
  constructor(props) {
    super(props);
    this.timestamp = Date.now();
  }

  render() {
    const { clientId, history } = this.props;
    return (
      <Query query={GET_CURRENT_USER}>
        {({ data: user, loading: loadingUser, error: getUserError }) => {
          if (loadingUser || getUserError || !user) {
            return null;
          }

          return (
            <Query
              query={GET_UNREAD_MESSAGE_COUNT}
              variables={{
                before: this.timestamp,
                clientId,
                viewerId: user.currentUser.id,
                group: getRoleGroup(user.currentUser.roles),
              }}
            >
              {({
                data: unreadMessages,
                loading: loadingUnreadMessages,
                error: unreadMessagesError,
                refetch,
              }) => {
                let unreadMessageCount = 0;
                if (!loadingUnreadMessages && !unreadMessagesError) {
                  unreadMessageCount = unreadMessages.unreadMessageData.count;
                }
                const handleRefetch = () => {
                  this.timestamp = Date.now();
                  refetch({ before: this.timestamp, clientId });
                };
                const handleIncomingPubNubMessage = buildIncomingPubNubMessageHandler(
                  clientId,
                  history,
                  handleRefetch,
                );
                const pubNubChannels = [`chat.${clientId}`];

                return (
                  <React.Fragment>
                    <PubNubSubscribe
                      channels={pubNubChannels}
                      onMessage={handleIncomingPubNubMessage}
                    />
                    <SidebarButton
                      appcuesElementId="appcues-button-messages"
                      isActive={history.location.pathname === '/'}
                      icon="messages"
                      notificationCount={unreadMessageCount}
                      onClick={() => history.push('/')}
                      testId="messages-sidebar-link"
                      text="Messages"
                    />
                  </React.Fragment>
                );
              }}
            </Query>
          );
        }}
      </Query>
    );
  }
}

MessageButtonContainer.propTypes = {
  clientId: PropTypes.string.isRequired,
  history: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
      search: PropTypes.string,
    }).isRequired,
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default MessageButtonContainer;
